import React from "react";
import {Card,CardContent} from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import {ItemIngreso} from './ItemIngreso'
import {modificarEstadoObligatorioTipoDocumento,deleteEstadoMarcadoTipoDocumento,nuevoEstadoMarcadoTipoDocumento} from '../../../actions/configuraciones/FormularioIngreso'
import { useDispatch } from "react-redux";

const useStyles = makeStyles({
    root:{
        width:500,
        background:'#212121'
    }
});



export const FormularioIngreso = (props) => {
  const classes = useStyles();
  const {items} = props;
  const dispatch = useDispatch();

  const handleChangeDelete = (id,idTipoDocumentaciones,idTipoAfiliacion,event) => {
    if(event.target.checked===true){
      //Realizamos Dispatch nuevo
      let body = {
        idTipoDocumentaciones:idTipoDocumentaciones,
        idTipoAfiliacion:idTipoAfiliacion,
        obligatorio:event.target.checked
      }
      dispatch(nuevoEstadoMarcadoTipoDocumento(id,body));
    }else{
      //Realizamos Dispatch delete
      dispatch(deleteEstadoMarcadoTipoDocumento(id));
    }
  };
  
  const handleChangeEditar = (marcado,idTipoDocumentaciones,idTipoAfiliacion,idTipoDocumentacionesTipoAfiliacion,event) => {
    
    let body = {
      idTipoDocumentaciones:idTipoDocumentaciones,
      idTipoAfiliacion:idTipoAfiliacion,
      obligatorio:event.target.checked
    }
    dispatch(modificarEstadoObligatorioTipoDocumento(marcado,idTipoDocumentacionesTipoAfiliacion,body));
  };

  return (
    <>
      {
        items&&
        <Card className={classes.root}>
            <CardContent>
                {
                    items.map(res => 
                        <ItemIngreso
                        key={res.idTipoDocumentaciones}
                        idTipoDocumentacionesTipoAfiliacion={res.idTipoDocumentacionesTipoAfiliacion} 
                        idTipoDocumentaciones={res.idTipoDocumentaciones} 
                        idTipoAfiliacion={res.idTipoAfiliacion} 
                        tipoDocumentaciones={res.tipoDocumentaciones?.descripcionDocumentacion}
                        handleChangeDelete={handleChangeDelete} handleChangeEditar={handleChangeEditar} 
                        name={res.idTipoDocumentaciones} 
                        obligatorio={res.obligatorio} 
                        marcado={res.marcado}/>
                        )
                }
            </CardContent>
       </Card>
      }
    </>
  );

};
